export default class GetSubtipoConvocatoriaById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(id) {
    try {
      const result = await this.#repository.getSubtipoConvocatoriaById(id)
      return result
    } catch (error) {
      console.error('Error al obtener el subtipo de convocatoria:', error)
      throw error
    }
  }
}
